var yearText = "Year";
var makeText = "Make";
var innovaApiUrl = $("#InnovaApiUrl").val();
var innovaApiKey = $("#InnovaKey").val();

$(document).ready(function () {    	
/*
                                   
    var clicked = false, base = 0;
    $('#results').on({
        mousemove: function(e) {
            clicked && function(xAxis) {
                var _this = $(this);
                if(base > xAxis) {
                    base = xAxis;
                    _this.css('margin-left', '-=1px');
                }
                if(base < xAxis) {
                    base = xAxis;
                    _this.css('margin-left', '+=1px');
                }
            }.call($(this), e.pageX);
        },
        mousedown: function(e) {
            clicked = true;
            base = e.pageX;
        },
        mouseup: function(e) {
            clicked = false;
            base = 0;
        }
    });
    
*/
  /*
   var dragdrop = new DragScroll({
     classContainer: "table"
   });
  dragdrop.doDragScroll();
*/
  
  //testApi();
  
  //playVideo();
  
  getProductVideo();
  
});

function testApi(){  
     
  	 xhr = $.ajax(
      {
        type: "GET",
        url: innovaApiUrl + "/dtc/test-makes",
        crossOrigin: true,
        beforeSend: function (xhr) {
            xhr.setRequestHeader('inn-api-auth-ticket', innovaApiKey);
        },
        //dataType: "text/html",
        error: function (xhr, status, error) {
          
        },
        success: function (data) {
          var result = data;
          
          if(result.makes.length > 0){
            var items = "<option value='' >"+ makeText +"</option>";
            $.each(result.makes, function (i, make) {             
                items += "<option value='" + make + "'>" + make + "</option>";             
            });
            $("#Year").html(items); 
          }
          
          
          
        }
      });   
  
}

function playVideo() {
  $(".youtube-video-wrapper").click(function(){
    var iframe = $(this).find("iframe")[0];
  	iframe.setAttribute("class", "shown");
    iframe.src += "&autoplay=1";
     //ev.preventDefault();
  });
  
  /*
  var iframe = document.getElementById("frame");

  img.setAttribute("class", "hidden");
  iframe.setAttribute("class", "shown");

  $("#frame")[0].src += "&autoplay=1";
  ev.preventDefault();
*/
  
}

function getProductVideo(){
  var innovaApiUrl = "https://dev.innova.com/api";//$("#InnovaApiUrl").val();
  var innovaApiKey = "H/Fp0tLdQVwq/DwPWwBcH7Rzacrf+59K2Ko9cmxxe648ygmh9TT7vJrmyyVf9vRh";//$("#InnovaKey").val();
  //var sku = $("#Tool").val();
  
  var url_string = window.location.href; 
  var urlStr = new URL(url_string);
  var sku = urlStr.searchParams.get("sku");
  
  var url = innovaApiUrl + "/products/" + sku +"/videos/?r=" + Math.random();

    
    $.ajax({
        type: "GET",
        crossOrigin: true,
        url: url,
        beforeSend: function (xhr) {
          xhr.setRequestHeader('inn-api-auth-ticket', innovaApiKey);
        },
        error: function () {
            alert(cannotLoadAjax);
        },
        success: function (result) {
          if(result.message.success && result.data != "" && result.data.indexOf("/embed/") > 0){
            $("#productVideo").attr("src", result.data + "?muted=1&amp;autoplay=0&amp;autopause=0&amp;loop=1");
          	$("#productVideoContent").show();                       
          }else{
            $("#productVideoContent").hide();         
          }
        }
    });  	
}